import {useEffect, useRef, useState} from "react";
import "./styles.scss";
import {useDispatch, useSelector} from "react-redux";
import {setModal, setModalData} from "../../../redux/actions/app/appActions";
import {POPUPS} from "../../../redux/actions/app/appActionTypes";
import {ReactComponent as ProjectIcon13} from '../../../assets/icons/play.svg';

const VideoWithPoster = ({src, chatId, id, indexVideo}) => {
    const dispatch = useDispatch();
    const videoRef = useRef(null);
    const observerRef = useRef(null);
    const [videoSrc, setVideoSrc] = useState(""); // Изначально без src
    const [posterSrc, setPosterSrc] = useState("");
    const [showImg, setShowImg] = useState(true);
    const {singleProject} = useSelector((state) => state.projects);

    useEffect(() => {
        observerRef.current = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVideoSrc(src);
                } else {
                    setVideoSrc("");
                }
            },
            {threshold: 0.5}
        );

        if (videoRef.current) {
            observerRef.current.observe(videoRef.current);
        }

        return () => {
            if (videoRef.current) {
                observerRef.current.unobserve(videoRef.current);
            }
        };
    }, [src]);

    useEffect(() => {
        if (!videoSrc || posterSrc) return;

        const video = videoRef.current;

        if (!video) return;

        const capturePoster = async () => {
            try {

                // await new Promise((resolve) => {
                //     console.log(video);
                //     if (video.readyState >= 2) resolve();
                //     else video.addEventListener("canplay", resolve, {once: true});
                // });
                video.currentTime = 0;

                await new Promise((resolve) => {
                    video.addEventListener("seeked", resolve, {once: true});
                });

                requestAnimationFrame(() => {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    setPosterSrc(canvas.toDataURL("image/jpeg"));
                    setShowImg(true);
                });
            } catch (error) {
                console.error("Ошибка загрузки постера:", error);
            }
        };

        capturePoster();
    }, [videoSrc]);

    const handlePlayVideo = () => {
        dispatch(setModal(POPUPS.VIDEO_POPUP))
        dispatch(setModalData({
            projectId: singleProject?.id,
            chatId,
            id,
            indexVideo
        }));

    };

    return (
        <div className={`video-chat`}>
            <video ref={videoRef} width="300" crossOrigin="anonymous" poster={posterSrc} preload={'metadata'}
                   playsInline muted={true}>
                {videoSrc &&
                    <source src={videoSrc + '#t=0.1'} type="video/mp4"/>}
                Ваш браузер не поддерживает видео.
            </video>
            {posterSrc && showImg ? (
                <div className={'videoPreview'}>
                    <img onClick={handlePlayVideo} src={posterSrc} alt="Постер" width="300"/>
                    <ProjectIcon13/>
                </div>
            ) : null}
        </div>
    );
};

export default VideoWithPoster;
